import request from '@/utils/request'
import { method } from '@/utils/constant'

const { POST, GET } = method

export default {
  // 获取缴费记录
  async getPaymentRecord(params) {
    return request({
      method: POST,
      url: '/member/payment/web/history/list',
      params,
    })
  },

  // 获取缴费通知
  async getPaymentNotice(params) {
    return request({
      method: POST,
      url: '/member/payment/web/list',
      params,
    })
  },

  // 获取缴费详情
  async getPaymentDetail(params) {
    return request({
      method: GET,
      url: `/member/payment/web/payment/detail/${params.id}`,
    })
  },

  // 获取欠费详情
  async getArrearageDetail(params) {
    return request({
      method: GET,
      url: `/member/payment/web/arrears/detail/${params.id}`,
    })
  },

  // 获取快递详情
  async getExpressSingleDetail(params) {
    return request({
      method: GET,
      url: `/member/courier/${params.id}`,
    })
  },
}
